import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";

import isAuthenticated from "../../services/auth";

import { Row, Col, Menu, Dropdown, Icon } from "antd";

import User from "./User";
import { FaPlus, FaFileExport, FaTasks } from "react-icons/fa";

import "./styles.css";
import { isSuperUser } from "../../utils/is-superuser";
import { MultiSearch } from "../Search/v2/multi-search";
import * as Permissions from "../../services/permissions";

class Header extends Component {
  state = {
    redirect: null
  };

  handleLogout = () => {
    localStorage.clear();

    this.setState({
      redirect: <Redirect to="/login" />
    });
  };

  handleToDashboard = () => {
    window.location.href = "/dashboard";
  };

  render() {
    if (this.state.redirect) return this.state.redirect;
    if (!isAuthenticated()) return <div />;

    const { SubMenu } = Menu;
    const explicitPermissions = (this.props.permissions || {})
      .explicit_permissions;
    const canViewNfePipeline =
      explicitPermissions !== null && explicitPermissions !== undefined
        ? explicitPermissions.indexOf(Permissions.NFE_VIEWER) !== -1
        : Permissions.has(Permissions.NFE_VIEWER);

    //const menu_admin = (
    // <Menu>
    //   {/* <Menu.Item>
    //     <Link to="/importacao" className="menu__item">
    //       Importação
    //     </Link>
    //   </Menu.Item>
    //   <Menu.Item>
    //     <Link to="/atividades" className="menu__item">
    //       Atividades
    //     </Link>
    //   </Menu.Item>
    //   <SubMenu title="Parcelas">
    //     <Menu.Item>
    //       <Link to="/pagar_parcelas/" className="menu__item">
    //         Pagar parcelas
    //       </Link>
    //     </Menu.Item>
    //     <Menu.Item>
    //       <Link to="/parcelas/" className="menu__item">
    //         Listar parcelas
    //       </Link>
    //     </Menu.Item>
    //   </SubMenu>
    //   <Menu.Item>
    //     <Link to="/user_list" className="menu__item">
    //       Usuarios
    //     </Link>
    //   </Menu.Item>
    //   <Menu.Item>
    //     <Link to="/config/acordo/tipos" className="menu__item">
    //       Configurações
    //     </Link>
    //   </Menu.Item>
    //   <Menu.Item>
    //     <Link to="/nota_fiscal/upload/" className="menu__item">
    //       nota_fiscal
    //     </Link>
    //   </Menu.Item>
    //   <Menu.Item>
    //     <Link to="/contaazul" className="menu__item">
    //       Conta Azul
    //     </Link>
    //   </Menu.Item>
    //   <Menu.Item>
    //     <Link to="/change_owner/" className="menu__item">
    //       Alterar Operador
    //     </Link>
    //   </Menu.Item> */}
    //   <Menu.Item>
    //     <Link to="/user_list" className="menu__item">
    //       Usuarios
    //     </Link>
    //   </Menu.Item>
    // </Menu>
    // );

    // const menu_crawlers = (
    //   <Menu>
    //     <Menu.Item>
    //       <Link to="/crawlers/devolucoes" className="menu__item">
    //         Devoluções
    //       </Link>
    //     </Menu.Item>
    //     <Menu.Item>
    //       <Link to="/crawlers/acionamentos" className="menu__item">
    //         Acionamentos
    //       </Link>
    //     </Menu.Item>
    //     <Menu.Item>
    //       <Link to="/crawlers/buscainfos" className="menu__item">
    //         Busca infos
    //       </Link>
    //     </Menu.Item>
    //     <Menu.Item>
    //       <Link to="/crawlers/causador" className="menu__item">
    //         Causador
    //       </Link>
    //     </Menu.Item>
    //   </Menu>
    // );

    const menu_sancor = (
      <Menu>
        <Menu.Item>
          <Link to="/sancor/cadastro" className="menu__item">
            Nova Pasta
          </Link>
        </Menu.Item>
      </Menu>
    );

    // const menu_filtro = (
    //   <Menu>
    //     <Menu.Item>
    //       <Link to="/filtro" className="menu__item">
    //         Filtro
    //       </Link>
    //     </Menu.Item>
    //     <Menu.Item>
    //       <Link to="/filtro/relatorio" className="menu__item">
    //         Relatório de filtros
    //       </Link>
    //     </Menu.Item>
    //   </Menu>
    // );

    // const menu_tabelas = (
    //   <Menu>
    //     <Menu.Item>
    //       <Link to="/pessoas" className="menu__item">
    //         Pessoa
    //       </Link>
    //     </Menu.Item>
    //   </Menu>
    // );

    const menu_relatorios = (
      <Menu>
        <Menu.Item>
          <Link to="/relatorios/parcela/" className="menu__item">
            Relatório Parcelas
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/relatorios/acordo/" className="menu__item">
            Relatório Acordos
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/relatorios/rateio/" className="menu__item">
            Relatório de Rateio
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/relatorios/prestacao-contas/" className="menu__item">
            Relatório de Prestação de Contas
          </Link>
        </Menu.Item>
        {/* <Menu.Item>
          <Link to="/relatorios/sms" className="menu__item">
            Relatório SMS
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/relatorios/smsHot" className="menu__item">
            Relatório SMS Hot
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/relatorios/rd" className="menu__item">
            Relatório Email
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/relatorios/acordo/" className="menu__item">
            Relatório Acordos
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/relatorios/filtro/planilha/" className="menu__item">
            Relatório Filtro
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/relatorios/pastas" className="menu__item">
            Relatório de Pastas
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/relatorio-sinistro-associado" className="menu__item">
            Relatório de Sinistro Associado
          </Link>
        </Menu.Item> */}
      </Menu>
    );

    // const menu_sms = (
    //   <Menu>
    //     <Menu.Item>
    //       <Link to="/sms/cadastro/" className="menu__item">
    //         Cadastrar Modelos
    //       </Link>
    //     </Menu.Item>
    //     <Menu.Item>
    //       <Link to="/sms/listagem_modelo/" className="menu__item">
    //         Modelos
    //       </Link>
    //     </Menu.Item>
    //     <Menu.Item>
    //       <Link to="/sms/envio/" className="menu__item">
    //         Envio
    //       </Link>
    //     </Menu.Item>
    //   </Menu>
    // );

    // const menu_user = (
    //   <Menu>
    //     <Menu.Item>
    //       <a onClick={this.handleLogout} className="menu__item">
    //         Sair
    //       </a>
    //     </Menu.Item>
    //   </Menu>
    // );

    const menu_contratos = (
      <Menu>
        <Menu.Item>
          <Link
            to="/contratos/relatorio?option=contratos"
            className="menu__item"
          >
            Relatório de Contratos
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link
            to="/contratos/relatorio?option=parcelas_excluidas"
            className="menu__item"
          >
            Relatório parcelas excluídas
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link
            to="/contratos/relatorio?option=parcelas_ativas"
            className="menu__item"
          >
            Relatório parcelas ativas
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link
            to="/contratos/relatorio?option=devedores"
            className="menu__item"
          >
            Relatório de devedores
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link
            to="/contratos/relatorio?option=historico_valor_parcelas"
            className="menu__item"
          >
            Relatório de Histórico Valor Parcelas
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/contratos/upload-txt" className="menu__item">
            Upload de TXT
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/contratos/upload-conta-corrente" className="menu__item">
            Importação de Conta Corrente
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/contratos/atualizacao-parcelas" className="menu__item">
            Atualização de Parcelas
          </Link>
        </Menu.Item>
      </Menu>
    );

    const menu_acordos = (
      <Menu>
        <Menu.Item>
          <Link to="/acordos/atualizar-parcelas" className="menu__item">
            Atualizar parcelas em lote
          </Link>
        </Menu.Item>
      </Menu>
    );

    return (
      <div className="header__container">
        <Row gutter={8} className="h-100 header__container_row m-0">
          <Col
            span={2}
            className="header__logo_part"
            onClick={this.handleToDashboard}
          >
            <h2>HUB</h2>
            <small>COBRANÇAS</small>
          </Col>

          <Col span={19}>
            <div className="options__container">
              <MultiSearch />
              {/*  */}

              <div className="options__option">
                <Link to="/tarefas" className="d-flex header__dropdown_item" style={{ color: 'inherit', textDecoration: 'none' }}>
                  <FaTasks style={{ marginRight: 8, marginTop: 4 }} />
                  Minhas solicitações
                </Link>
              </div>

              {canViewNfePipeline && (
                <div className="options__option">
                  <Link
                    to="/nfe-pipeline"
                    className="d-flex header__dropdown_item"
                    style={{ color: 'inherit', textDecoration: 'none' }}
                  >
                    <Icon type="file-text" style={{ marginRight: 8, marginTop: 4 }} />
                    Emissão NFe
                  </Link>
                </div>
              )}

              {isSuperUser() && (
                <div className="options__option">
                  {/* Sancor */}
                  <Dropdown
                    overlay={menu_sancor}
                    overlayClassName="header__dropdown"
                  >
                    <a className="d-flex header__dropdown_item">
                      <FaPlus />
                      &nbsp;&nbsp;Nova Pasta
                    </a>
                  </Dropdown>
                </div>
              )}

              {isSuperUser() && (
                <div className="options__option">
                  {/* Relatorios */}
                  <div>
                    <Dropdown
                      overlay={menu_relatorios}
                      overlayClassName="header__dropdown"
                    >
                      <a className="d-flex header__dropdown_item">
                        <FaFileExport />
                        &nbsp;&nbsp;Relatórios Acordo
                      </a>
                    </Dropdown>
                  </div>
                </div>
              )}

              {isSuperUser() && (
                <div className="options__option">
                  {/* Contratos */}
                  <div>
                    <Dropdown
                      overlay={menu_contratos}
                      overlayClassName="header__dropdown"
                    >
                      <a className="d-flex header__dropdown_item">
                        <Icon type="bank" />
                        &nbsp;&nbsp;Contratos
                      </a>
                    </Dropdown>
                  </div>
                </div>
              )}

              {isSuperUser() && (
                <div className="options__option">
                  {/* Acordos */}
                  <div>
                    <Dropdown
                      overlay={menu_acordos}
                      overlayClassName="header__dropdown"
                    >
                      <a className="d-flex header__dropdown_item">
                        <Icon type="dollar" />
                        &nbsp;&nbsp;Acordos
                      </a>
                    </Dropdown>
                  </div>
                </div>
              )}

              {isSuperUser() && (
                <div className="options__option">
                  {/* Admin */}
                  <Dropdown
                    overlay={
                      <Menu>
                        <Menu.Item>
                          <Link to="/user_list" className="menu__item">
                            Usuários
                          </Link>
                        </Menu.Item>
                      </Menu>
                    }
                    overlayClassName="header__dropdown"
                  >
                    <a className="d-flex header__dropdown_item">
                      <Icon type="setting" />
                      &nbsp;&nbsp;Administração
                    </a>
                  </Dropdown>
                </div>
              )}
            </div>
          </Col>
          <Col span={3} align="center">
            <User logoutfn={this.handleLogout} />
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect(state => ({
  permissions: state.permissions
}))(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js